import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Container,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    FormHelperText,
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import adminService from "../../../../services/admin.service";
import competencyMasterService from "../../../../services/competencyMaster.service";

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const CompetencyMasterCreate = (props) => {
    const { t } = useTranslation();
    let { serial, cycleID } = useParams()
    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },

        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        disabled: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            }
        },
    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false, state: { cycleID: cycleID } });
    }
    const classes = useStyles();

    const [checkCode, setCheckCode] = React.useState(false);
    const [status, setStatus] = React.useState(true);
    const [edit, setEdit] = React.useState(true);
    const [save, setSave] = React.useState(false);
    // const [backgroundColorStatus, setBackgroundColorStatus] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [adjust, setAdjust] = React.useState(true);
    const [statusUse, setStatusUse] = React.useState(false);
    const handleStatus = () => {
        setStatus(!status)
    }
    const [defaults, setDefault] = React.useState(false);
    const onCheckDefault = () => {
        setDefault(!defaults)
    }

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
        "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
            backgroundColor: "#D8D8D8!important"
        }
    }));
    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        nameEN: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        // nameTH: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
    });
    const formik = useFormik({
        initialValues: {
            code: '',
            nameEN: '',
            nameTH: '',
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            if (serial !== undefined && serial !== null) {
                submit(values)
            } else {
                adminService.checkCode("competency_category", values.code, cycleID).then(
                    (response) => {
                        setCheckCode(response?.data?.is_exist)
                        if (response?.data?.is_exist === false) {
                            submit(values)
                        }
                    },
                ).catch(() => {
                })
            }
        },
    });

    useEffect(() => {
        if (checkCode === true) {
            setCheckCode(false)
        }
    }, [formik.values.code]);

    useEffect(() => {
        if (serial !== undefined && serial !== null) {
            competencyMasterService.getEditCompetencyMaster(serial).then((rs) => {
                formik.setFieldValue("code", rs?.data?.competency_category?.code)
                formik.setFieldValue("nameEN", rs?.data?.competency_category?.options?.name_en !== undefined && rs?.data?.competency_category?.options?.name_en !== null ? rs?.data?.competency_category?.options?.name_en : rs?.data?.competency_category?.name)
                formik.setFieldValue("nameTH", rs?.data?.competency_category?.options?.name_th)
                setStatus(rs?.data?.competency_category?.status === "active" ? true : false)
                // setAdjust(rs?.data?.cycle?.options?.allow_adjust === true ? true : false)
                setEdit(rs?.data?.competency_category?.code)
                setSave(false)
                setStatusUse(rs?.data?.competency_category?.is_used)
            })
        }
    }, []);
    useEffect(() => {
        if (save === false) {
            setSave(true)
        }
    }, [formik.values, status, defaults]);
    const handleSubmit = () => {
        formik.submitForm()
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }

    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        clickLink('/admin/competency-master')
        // navigate('/admin/goal-component', { replace: false });
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [isAddDialogOpen, openDialog] = React.useState(false);
    const handleOpenDialog = (value) => {
        openDialog(true);
    };
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/competency-master', { replace: false, state: { cycleID: cycleID } });
    }
    const submit = () => {
        if (serial !== undefined && serial !== null) {
            competencyMasterService.editCompetencyMaster(serial, {
                "cycle_id": cycleID,
                "code": formik.values.code,
                "name_th": formik.values.nameTH,
                "name_en": formik.values.nameEN,
                "status": status === true ? "active" : "inactive",
                "options": {}
            }).then(
                (response) => {
                    openSuccessAddDialog(true)
                },
            ).catch(() => {
                seterrorText(t(`admin.label.competencyMasterEditFail`))
                handleOpenFailedMessageDialog(true)
            })
        } else {
            competencyMasterService.createCompetencyMaster({
                "cycle_id": cycleID,
                "code": formik.values.code,
                "name_th": formik.values.nameTH,
                "name_en": formik.values.nameEN,
                "status": status === true ? "active" : "inactive",
                "options": {}
            }).then(
                (response) => {
                    openSuccessAddDialog(true)
                },
            ).catch(() => {
                seterrorText(t(`admin.label.competencyMasterCreatedFail`))
                handleOpenFailedMessageDialog(true)
            })
        }

    }

    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/competency-master')}>{t('admin.label.competencyMaster')}</span> / <span style={styles.end} >{serial !== undefined ? t('admin.label.editCompetencyMaster') : t('admin.label.createCompetencyMaster')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" color="#404349" fontSize={36} lineHeight="53.82px" fontWeight="600">
                                {serial !== undefined ? t('admin.label.editCompetencyMaster') : t('admin.label.createCompetencyMaster')}
                            </Typography>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">

                            <Grid container item>
                                <Paper elevation={6} sx={{ 'border-radius': '10px', width: '100%' }} classes={{ root: classes.error }}>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "50px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                                            <Typography variant="subtitle1" color="#404349" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.code')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.code && formik.errors.code) === false ? checkCode === true ? true : false : true}
                                                fullWidth
                                                helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="code"
                                                disabled={serial !== undefined ? true : false}
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.code}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.code')}
                                                classes={{ root: serial !== undefined ? adjust === true ? classes.input : classes.disabled : classes.input }}
                                            />
                                            {Boolean(formik.touched.code && formik.errors.code) === false && checkCode === true ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('label.alreadyUsed')} </FormHelperText>) : <></>}
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} color="#404349" lineHeight="24px" display="flex">{t('admin.inputForm.status')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Box sx={{ paddingTop: "16px", height: "100%", "max-height": "55px", display: "flex", "align-items": "center" }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0 }}
                                                        control={<IOSSwitch checked={status} disabled={serial !== undefined ? statusUse === true ? true : false : false} onChange={() => handleStatus()} />}
                                                        label={status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    // disabled
                                                    />
                                                </FormGroup>
                                                {/* <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography> */}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": edit === false ? "#FAFAFA" : "", "-webkit-text-fill-color": edit === false ? "#000 !important" : "" }, "fieldset": { "border-color": edit === false ? "#FFFFFF !important" : "" } }}>
                                            <Typography variant="subtitle1" fontSize={18} color="#404349" lineHeight="24px" display="flex">{t('admin.inputForm.nameEN')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.nameEN && formik.errors.nameEN)}
                                                fullWidth
                                                helperText={formik.touched.nameEN && formik.errors.nameEN}
                                                margin="normal"
                                                name="nameEN"
                                                disabled={serial !== undefined ? adjust === true ? false : true : false}
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.nameEN}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.nameEN')}
                                                classes={{ root: serial !== undefined ? adjust === true ? classes.input : classes.disabled : classes.input }}
                                            />
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": edit === false ? "#FAFAFA" : "", "-webkit-text-fill-color": edit === false ? "#000 !important" : "" }, "fieldset": { "border-color": edit === false ? "#FFFFFF !important" : "" } }}>
                                            <Typography variant="subtitle1" fontSize={18} color="#404349" lineHeight="24px" display="flex">{t('admin.inputForm.nameTH')}</Typography>
                                            <TextField
                                                error={Boolean(formik.touched.nameTH && formik.errors.nameTH)}
                                                fullWidth
                                                helperText={formik.touched.nameTH && formik.errors.nameTH}
                                                margin="normal"
                                                name="nameTH"
                                                disabled={serial !== undefined ? adjust === true ? false : true : false}
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.nameTH}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.nameTH')}
                                                classes={{ root: serial !== undefined ? adjust === true ? classes.input : classes.disabled : classes.input }}
                                            />
                                        </Grid>
                                    </Grid>
                                    {serial !== undefined ?
                                        adjust === true ?
                                            <Grid container mt={3} mb={3} pr={4} >
                                                <Grid item xs display="flex" flexDirection="row-reverse">
                                                    <Box sx={{ width: "100px" }}>
                                                        <Button disabled={save === true ? edit === false ? true : false : true} onClick={handleSubmit} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
                                                            {serial !== undefined ? "Save" : "Create"}
                                                        </Button>
                                                    </Box>
                                                    <Box mr={2} sx={{ width: "100px" }}>
                                                        <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none" }}>
                                                            {/* {t('label.cancel')} */}
                                                            Cancel
                                                        </Button>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            : null
                                        :
                                        <Grid container mt={3} mb={3} pr={4} >
                                            <Grid item xs display="flex" flexDirection="row-reverse">
                                                <Box sx={{ width: "100px" }}>
                                                    <Button disabled={save === true ? edit === false ? true : false : true} onClick={handleSubmit} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
                                                        {serial !== undefined ? "Save" : "Create"}
                                                    </Button>
                                                </Box>
                                                <Box mr={2} sx={{ width: "100px" }}>
                                                    <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none" }}>
                                                        {/* {t('label.cancel')} */}
                                                        Cancel
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    }

                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={serial !== undefined ? t(`admin.label.competencyMasterEditSuccessfully`) : t(`admin.label.competencyMasterCreatedSuccessfully`)}
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={errorText + t(`dialog.label.tryAgain`)}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                </Container>
            </Box>
        </>
    )
};
export default CompetencyMasterCreate;
